export default {
  'zh-CN': {
    home: {
      title: '芙崽 Fuzozo',
      subtitle: '开发调试面板',
      languageTitle: '语言参数',
      languageDesc: '给跳转链接统一附带 lang 参数',
      appSection: '应用入口',
      appDownload: 'APP 下载',
      appDownloadDesc: '打开统一下载页，选择 iOS App Store 或 Android 安装包',
      taskSection: '任务页面',
      newbieTask: '新手任务',
      dailyTask: '成长任务',
      dlpId: 'dlpId',
      dlpPlaceholder: '输入 dlpId',
      token: 'Token',
      tokenPlaceholder: '粘贴 token（选填）',
      mockLabel: 'Mock 数据',
      debugLabel: 'API 调试',
      toggleOn: '开启',
      toggleOff: '关闭',
      enterPage: '进入页面',
      legalSection: '法律文件',
      privacyPolicy: '隐私政策',
      userAgreement: '用户服务协议',
      personalInfoCollection: '个人信息收集清单',
      thirdPartySharing: '第三方信息共享清单',
      dataDeletion: '数据删除说明',
      qaSection: '帮助与 QA',
      deviceHelpQa: '帮助 QA',
      digitalLifeQa: '数字生命 QA',
      previewSection: '快速预览（Mock）',
      newbiePreview: '新手任务（Mock 数据）',
      dailyPreview: '成长任务（Mock 数据）'
    }
  },
  en: {
    home: {
      title: 'Fuzozo',
      subtitle: 'Developer Debug Panel',
      languageTitle: 'Language Parameter',
      languageDesc: 'Append a unified `lang` query to all routes',
      appSection: 'App Entry',
      appDownload: 'App Download',
      appDownloadDesc: 'Open the unified download page for the iOS App Store or Android APK',
      taskSection: 'Task Pages',
      newbieTask: 'Beginner Task',
      dailyTask: 'Growth Task',
      dlpId: 'dlpId',
      dlpPlaceholder: 'Enter dlpId',
      token: 'Token',
      tokenPlaceholder: 'Paste token (optional)',
      mockLabel: 'Mock Data',
      debugLabel: 'API Debug',
      toggleOn: 'On',
      toggleOff: 'Off',
      enterPage: 'Open Page',
      legalSection: 'Legal Pages',
      privacyPolicy: 'Privacy Policy',
      userAgreement: 'User Service Agreement',
      personalInfoCollection: 'Personal Information Collection List',
      thirdPartySharing: 'Third-Party Information Sharing List',
      dataDeletion: 'Data Deletion Instructions',
      qaSection: 'Help & Q&A',
      deviceHelpQa: 'Help Q&A',
      digitalLifeQa: 'Digital Life Q&A',
      previewSection: 'Quick Preview (Mock)',
      newbiePreview: 'Beginner Task (Mock)',
      dailyPreview: 'Growth Task (Mock)'
    }
  },
  ja: {
    home: {
      title: 'フーゾゾ Fuzozo',
      subtitle: '開発デバッグパネル',
      languageTitle: '言語パラメータ',
      languageDesc: 'すべての遷移先に統一して `lang` を付与します',
      appSection: 'アプリ導線',
      appDownload: 'アプリダウンロード',
      appDownloadDesc: 'iOS App Store または Android APK を選べる統一ダウンロードページを開きます',
      taskSection: 'タスクページ',
      newbieTask: '初心者タスク',
      dailyTask: '成長タスク',
      dlpId: 'dlpId',
      dlpPlaceholder: 'dlpId を入力',
      token: 'Token',
      tokenPlaceholder: 'token を貼り付け（任意）',
      mockLabel: 'Mock データ',
      debugLabel: 'API デバッグ',
      toggleOn: 'オン',
      toggleOff: 'オフ',
      enterPage: 'ページを開く',
      legalSection: '法務ページ',
      privacyPolicy: 'プライバシーポリシー',
      userAgreement: '利用規約',
      personalInfoCollection: '個人情報収集一覧',
      thirdPartySharing: '第三者情報共有一覧',
      dataDeletion: 'データ削除案内',
      qaSection: 'ヘルプとQ&A',
      deviceHelpQa: 'ヘルプQ&A',
      digitalLifeQa: 'デジタルライフQ&A',
      previewSection: 'クイックプレビュー（Mock）',
      newbiePreview: '初心者タスク（Mock）',
      dailyPreview: '成長タスク（Mock）'
    }
  },
  'zh-TW': {
    home: {
      title: '芙崽 Fuzozo',
      subtitle: '開發調試面板',
      languageTitle: '語言參數',
      languageDesc: '為所有跳轉統一附帶 lang 參數',
      appSection: '應用入口',
      appDownload: 'APP 下載',
      appDownloadDesc: '開啟統一下載頁，選擇 iOS App Store 或 Android 安裝包',
      taskSection: '任務頁面',
      newbieTask: '新手任務',
      dailyTask: '成長任務',
      dlpId: 'dlpId',
      dlpPlaceholder: '輸入 dlpId',
      token: 'Token',
      tokenPlaceholder: '貼上 token（選填）',
      mockLabel: 'Mock 資料',
      debugLabel: 'API 除錯',
      toggleOn: '開啟',
      toggleOff: '關閉',
      enterPage: '進入頁面',
      legalSection: '法律文件',
      privacyPolicy: '隱私政策',
      userAgreement: '使用者服務協議',
      personalInfoCollection: '個人資訊蒐集清單',
      thirdPartySharing: '第三方資訊共享清單',
      dataDeletion: '資料刪除說明',
      qaSection: '幫助與 QA',
      deviceHelpQa: '幫助 QA',
      digitalLifeQa: '數位生命 QA',
      previewSection: '快速預覽（Mock）',
      newbiePreview: '新手任務（Mock 資料）',
      dailyPreview: '成長任務（Mock 資料）'
    }
  }
}
